import { render, staticRenderFns } from "./KeseminatanEdit.vue?vue&type=template&id=7c4c95c2&scoped=true"
import script from "./KeseminatanEdit.vue?vue&type=script&lang=js"
export * from "./KeseminatanEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c4c95c2",
  null
  
)

export default component.exports